/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameObjectIdObjectRelationships =
  "/data_objects/:type_name/:object_id/object_relationships" as const;
